<button class="float-right"
        *ngIf="!readOnly"
        (click)="deleteLocation.emit()">
    <fa-icon [icon]="faTimes"></fa-icon>
</button>

<form [formGroup]="paramGroup">

    <div class="d-flex align-items-center">
    <mat-form-field class="number-field">
        <input matInput formControlName="location_const" [placeholder]="'location_const' | translate">
        <mat-error *ngIf="paramGroup.get('location_const').hasError('required')">
            {{'REQUIRED' | translate}}
        </mat-error>
        <mat-error *ngIf="paramGroup.get('location_const').hasError('not a number')">
            {{'NUMBER_REQUIRED' | translate}}
        </mat-error>
    </mat-form-field>
    <span class="expression-elements" [ngClass]="{readOnly: readOnly}">x</span>
    <span class="expression-elements" [ngClass]="{readOnly: readOnly}">(</span>

    <div>

    <app-location-autocomplete-input
            index="1"
            [locationControl]="paramGroup.get('location_1')"
            [readOnly]="readOnly">
    </app-location-autocomplete-input>

    <mat-form-field class="number-field">
        <input matInput
               formControlName="exp_1"
               [placeholder]="('exp' | translate) + ' ' + 1">
        <mat-error *ngIf="paramGroup.get('exp_1').hasError('required')">
            {{'REQUIRED' | translate}}
        </mat-error>
        <mat-error *ngIf="paramGroup.get('exp_1').hasError('not a number')">
            {{'NUMBER_REQUIRED' | translate}}
        </mat-error>
    </mat-form-field>
    </div>
    <span class="expression-elements" [ngClass]="{readOnly: readOnly}">)</span>
    </div>

    <span class="expression-elements first-element-left" [ngClass]="{readOnly: readOnly}">x</span>
    <span class="expression-elements" [ngClass]="{readOnly: readOnly}">(</span>

    <app-location-autocomplete-input
            index="2"
            [locationControl]="paramGroup.get('location_2')"
            [readOnly]="readOnly">
    </app-location-autocomplete-input>

    <mat-form-field class="number-field">
        <input matInput
               formControlName="exp_2"
               [placeholder]="('exp' | translate) + ' ' + 2">
        <mat-error *ngIf="paramGroup.get('exp_2').hasError('required')">
            {{'REQUIRED' | translate}}
        </mat-error>
        <mat-error *ngIf="paramGroup.get('exp_2').hasError('not a number')">
            {{'NUMBER_REQUIRED' | translate}}
        </mat-error>
    </mat-form-field>

    <span class="expression-elements" [ngClass]="{readOnly: readOnly}">)</span>

</form>
